import jwt_decode from 'jwt-decode';
export default {
    name: "Edit",
    data() {
        return {
            form: {
                id: null,
                userAccount: null,
                oldPass: null,
                newPass: null,
                newPassConfirm: null
            }
        }
    },
    mounted: function () {
    },
    computed: {
        rules() {
            const checkPass = (rule, value, callback) => {
                // this.form.clearValidate(['newPass', 'newPassConfirm']);
                // this.form.validateField(['newPass', 'newPassConfirm']);
                if (this.form.newPass && this.form.newPassConfirm && this.form.newPass !== this.form.newPassConfirm) {
                    callback(new Error(this.$t('userManage.message.passNotMatch')))
                } else {
                    callback()
                }
            };
            return {
                userAccount: [
                    {required: true, message: this.$t('userManage.message.userAccount'), trigger: 'blur'},
                    {max: 50, message: this.$t('userManage.message.tooLong') + 50, trigger: 'blur'}
                ],
                oldPass: [
                    {required: true, message: this.$t('userManage.message.oldPass'), trigger: 'blur'},
                    {max: 16, message: this.$t('userManage.message.tooLong') + 16, trigger: 'blur'}
                ],
                newPass: [
                    {required: true, message: this.$t('userManage.message.newPass'), trigger: 'blur'},
                    {max: 16, message: this.$t('userManage.message.tooLong') + 16, trigger: 'blur'},
                    // {validator: checkPass, trigger: 'blur'}
                ],
                newPassConfirm: [
                    {required: true, message: this.$t('userManage.message.newPassConfirm'), trigger: 'blur'},
                    {max: 16, message: this.$t('userManage.message.tooLong') + 16, trigger: 'blur'},
                    {validator: checkPass, trigger: ['blur', 'change']}
                ]
            }
        },
    },
    created() {
        this.form.id = jwt_decode(sessionStorage.getItem('token')).userAccountId;
        this.form.userAccount = jwt_decode(sessionStorage.getItem('token')).userAccount;
    },
    methods: {
        edit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const param = Object.assign({}, param, this.form);
                    this.$axios.put('/api/accounts/modifyPassword', {params: param}).then(response => {
                        if (response.data.status === '1') {
                            this.$message({
                                message: this.$t('userManage.message.passwordModifySucceed'),
                                type: 'success',
                                center: true
                            });
                        } else {
                            this.$message({
                                message: this.$t('userManage.message.passwordModifyFailed'),
                                type: 'error',
                                center: true
                            });
                        }
                    }).catch(e => {
                        console.log(e);
                        this.$message({
                            message: this.$t('userManage.message.passwordModifyFailed'),
                            type: 'error',
                            center: true
                        });
                    });
                }
            });
        },
        back() {
            this.$router.back();
        }
    }
}
